"use client";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const BotVideoSection = ({ data }) => {
  const videoRef = useRef(null);
  const [videoHeight, setVideoHeight] = useState("auto");
  const [isLoaded, setIsLoaded] = useState(false);
  const videoUrl = data?.url || data?.video?.url || data?.videoUrl || "https://pub-0705ed3bb3a5425799ba64b1bd76a81b.r2.dev/shared_media/StarVideo.mp4";

  useEffect(() => {
    const videoElement = videoRef.current;
    const updateHeight = () => {
      if (videoElement && videoElement.videoWidth > 0) {
        const ratio = videoElement.videoHeight / videoElement.videoWidth;
        const width = videoElement.clientWidth;
        setVideoHeight(width * ratio);
      }
    };
    const handleLoadedMetadata = () => {
      updateHeight();
      setIsLoaded(true);
    };
    const handleCanPlay = () => {
      if (videoElement) {
        videoElement.play().catch((error) => {
          console.log("Autoplay prevented:", error);
        });
      }
    };
    if (videoElement) {
      videoElement.addEventListener("loadedmetadata", handleLoadedMetadata);
      videoElement.addEventListener("canplay", handleCanPlay);
      if (videoElement.readyState >= 1) {
        handleLoadedMetadata();
      }
    }
    window.addEventListener("resize", updateHeight);
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadedmetadata", handleLoadedMetadata);
        videoElement.removeEventListener("canplay", handleCanPlay);
      }
      window.removeEventListener("resize", updateHeight);
    };
  }, [videoUrl]);
  useEffect(() => {
    if (videoRef.current) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log("Autoplay prevented:", error);
        });
      }
    }
  }, []);
  return (
    <motion.div
      className="w-full overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: isLoaded ? 1 : 0 }}
      transition={{ duration: 0.5 }}
    >
      <video
        ref={videoRef}
        className="w-full"
        style={{ height: videoHeight }}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </motion.div>
  );
};

export default BotVideoSection;
